var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "#FAFAFA",
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2471 21.6102H14.9536C16.1596 21.6102 17.3162 22.0892 18.1689 22.942C19.0217 23.7947 19.5007 24.9513 19.5007 26.1573V27.0082C19.5007 27.2461 19.4062 27.4743 19.238 27.6425C19.0698 27.8107 18.8417 27.9052 18.6038 27.9052H9.59696C9.35907 27.9052 9.13092 27.8107 8.96271 27.6425C8.7945 27.4743 8.7 27.2461 8.7 27.0082V26.1573C8.7 24.9513 9.17907 23.7947 10.0318 22.942C10.8846 22.0892 12.0412 21.6102 13.2471 21.6102Z",
    stroke: "#613ED2",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7206 19.0404C15.2411 19.3608 14.6775 19.5318 14.1008 19.5319C13.328 19.5309 12.5871 19.2235 12.0404 18.6772C11.4938 18.1309 11.186 17.3902 11.1844 16.6174C11.1841 16.0407 11.3548 15.4769 11.6749 14.9973C11.9951 14.5175 12.4504 14.1435 12.9832 13.9225C13.516 13.7015 14.1023 13.6435 14.6681 13.7558C15.2338 13.8681 15.7536 14.1457 16.1616 14.5534C16.5696 14.9611 16.8475 15.4807 16.9601 16.0464C17.0728 16.6121 17.0152 17.1985 16.7945 17.7314C16.5739 18.2644 16.2001 18.7199 15.7206 19.0404Z",
    stroke: "#613ED2",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2471 19.6102H27.9536C29.1596 19.6102 30.3162 20.0892 31.1689 20.942C32.0217 21.7947 32.5007 22.9513 32.5007 24.1573V25.0082C32.5007 25.2461 32.4062 25.4743 32.238 25.6425C32.0698 25.8107 31.8417 25.9052 31.6038 25.9052H22.597C22.3591 25.9052 22.1309 25.8107 21.9627 25.6425C21.7945 25.4743 21.7 25.2461 21.7 25.0082V24.1573C21.7 22.9513 22.1791 21.7947 23.0318 20.942C23.8846 20.0892 25.0412 19.6102 26.2471 19.6102Z",
    stroke: "#613ED2",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7206 17.0404C28.2411 17.3608 27.6775 17.5318 27.1008 17.5319C26.328 17.5309 25.5871 17.2235 25.0404 16.6772C24.4938 16.1309 24.186 15.3902 24.1844 14.6174C24.1841 14.0407 24.3548 13.4769 24.6749 12.9973C24.9951 12.5175 25.4504 12.1435 25.9832 11.9225C26.516 11.7015 27.1023 11.6435 27.6681 11.7558C28.2338 11.8681 28.7536 12.1457 29.1616 12.5534C29.5696 12.9611 29.8475 13.4807 29.9601 14.0464C30.0728 14.6121 30.0152 15.1985 29.7945 15.7314C29.5739 16.2644 29.2001 16.7199 28.7206 17.0404Z",
    stroke: "#613ED2",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.4a11d6796ec99e915a0e5cd3687bc819.svg";
export { ForwardRef as ReactComponent };